// extracted by mini-css-extract-plugin
var _1 = "RichTextDescriptionControl-module__animatedBackground--LptQI";
var _2 = "RichTextDescriptionControl-module__disabled--TdWwd";
var _3 = "RichTextDescriptionControl-module__editor--X_uub";
var _4 = "RichTextDescriptionControl-module__editorContainer--xXvcJ";
var _5 = "RichTextDescriptionControl-module__error--bwVmX";
var _6 = "RichTextDescriptionControl-module__expanded--HCuKY";
var _7 = "RichTextDescriptionControl-module__label--ddKSA";
var _8 = "RichTextDescriptionControl-module__tip--B5Z3h";
export { _1 as "animatedBackground", _2 as "disabled", _3 as "editor", _4 as "editorContainer", _5 as "error", _6 as "expanded", _7 as "label", _8 as "tip" }
